import React, { Component } from 'react';
import './style.scss';

export interface IMenuSwitchProps {
    opened: boolean;
    onClick: React.MouseEventHandler;
}

class MenuSwitch extends Component<IMenuSwitchProps> {
    static defaultProps = {
        opened: false
    };

    render() {
        const { opened, onClick } = this.props;

        return (
            <div onClick={onClick} className={`menu-switch-root ${opened ? 'menu-switch-opened' : ''}`}>
                <span />
            </div>
        );
    }
}

export default MenuSwitch;
